import React from "react";
import Footer from "../common/Footer";
import Banner from "./banner";
import Header from "../common/header";
import TelecomIntegration from "./TelecomIntegration";
import BrandIntegration from "./BrandIntegration";
import TournamentServices from "./TournamentServices";
import Clients from "./Clients";
import Numbers from "./WhyChooseUs";
const Services = () => {


    return (
        <div className="w-full h-full bg-[#070B28]">
            <Header />
            <Banner />
            <TelecomIntegration />
            <BrandIntegration />
            <TournamentServices />

            <Numbers />
            <Clients />
            <Footer />
        </div>

    );
};

export default Services;
